import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './i18n/config.js';
import './styles.css';

const root = document.getElementById('root');

if (!root) throw new Error('root element not found');

createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
